import LiveBoardScreenComponent from "./live-board-screen-component";
import ReactModal from "react-modal";
import { componentStyles } from "./live-board-modal.scss";

const liveBoardPopupModal = (props) => {
  const { showLiveBoard, closeLiveBoard, translate } = props;

  return (
    <ReactModal className="live-board-modal" overlayClassName="live-board-modal-overlay" isOpen={showLiveBoard}>
      <LiveBoardScreenComponent translate={translate} closeLiveBoard={closeLiveBoard} />
      <style jsx>{componentStyles}</style>
    </ReactModal>
  );
};

export default liveBoardPopupModal;
